import { gql } from '@apollo/client'

export interface LspayTippingConfig {
  outletID: string
  status: string
  calculateBeforeTax: boolean
}

export interface LspayTippingConfigData {
  lspayTippingConfig: LspayTippingConfig[]
}

export interface LspayTippingConfigRequest {
  outletIDs: string[]
}

export const GET_LSPAY_TIPPING_CONFIGS = gql`
  query LspayTippingConfig($outletIDs: [ID!]) {
    lspayTippingConfig(outletIDs: $outletIDs) {
      outletID
      status
      calculateBeforeTax
    }
  }
`
